import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import DailySalesReportAPI from './../../../api/DailySalesReportAPI';
import ChartComponent from "../FixedReportChart";

class DailySalesLeadByRentSale extends React.Component {
  constructor(props) {
    super(props);

    // Load source options from local storage
    const propertyTransactionOptions = reactLocalStorage.getObject(Constants.Model).property.fields.property_transaction.options;

    this.state = {
      propertyTransactionOptions,  // Predefined source options
      PropertySums : {},
    };
  }

  componentDidMount() {
    // Fetch data from the API
    DailySalesReportAPI.getleadsByRentSale(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    const {  propertyTransactionOptions } = this.state;
     // Create a record of sums for each project option, starting at 0
     const PropertySums = propertyTransactionOptions.reduce((acc, option) => {
        acc[option.value] = 0;
        return acc;
     }, {});
 
     // Fill in the actual values from the API data
     data.forEach(item => {
       const project =  [item.property_transaction];
       project.forEach(pr => {
           PropertySums[parseInt(pr)] += item.sum;
       })
     });
    this.setState({PropertySums});
    
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { PropertySums, propertyTransactionOptions } = this.state;
    // Calculate the total sum of all source values
    const totalSum = Object.values(PropertySums).filter(Boolean).reduce((total, value) => total + value, 0);
    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>  Property Rent / Sale Report</h2>
          <hr />
          <div className="row mt-3">
          <Table striped bordered hover className="col-md-5">
            <thead>
              <tr>
                <th>Configuration</th>
                <th>Total Properties</th>
              </tr>
            </thead>
            <tbody>
              {propertyTransactionOptions.map((option, index) => (
                <tr key={index}>
                  <td>{option.label}</td> 
                  <td>{PropertySums[option.value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-5">
            {/* Add Chart Component */}
            <ChartComponent progressSums={PropertySums} progressOptions={propertyTransactionOptions} type="bar" />
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(DailySalesLeadByRentSale);
